import { render, staticRenderFns } from "./PurchaseRecipesTab.vue?vue&type=template&id=5f308e7f&scoped=true&"
import script from "./PurchaseRecipesTab.vue?vue&type=script&lang=js&"
export * from "./PurchaseRecipesTab.vue?vue&type=script&lang=js&"
import style0 from "./PurchaseRecipesTab.vue?vue&type=style&index=0&id=5f308e7f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f308e7f",
  null
  
)

export default component.exports